export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /**
   * The `Date` scalar type represents a Date
   * value as specified by
   * [iso8601](https://en.wikipedia.org/wiki/ISO_8601).
   */
  Date: { input: any; output: any; }
  /**
   * The `DateTime` scalar type represents a DateTime
   * value as specified by
   * [iso8601](https://en.wikipedia.org/wiki/ISO_8601).
   */
  DateTime: { input: any; output: any; }
  /** The `Decimal` scalar type represents a python Decimal. */
  Decimal: { input: any; output: any; }
  /** An int representing an id field */
  IDInt: { input: any; output: any; }
  /**
   * Allows use of a JSON String for input / output from the GraphQL schema.
   *
   * Use of this type is *not recommended* as you lose the benefits of having a defined, static
   * schema (one of the key benefits of GraphQL).
   */
  JSONString: { input: any; output: any; }
  /**
   * Create scalar that ignores normal serialization/deserialization, since
   * that will be handled by the multipart request spec
   */
  Upload: { input: any; output: any; }
};

export type AccrualPeriod = {
  __typename?: 'AccrualPeriod';
  amount: Scalars['Float']['output'];
  date: Scalars['Date']['output'];
};

export type AccrualPeriodInfo = {
  __typename?: 'AccrualPeriodInfo';
  beginningBal?: Maybe<Scalars['Float']['output']>;
  error?: Maybe<Error>;
  periods?: Maybe<Array<Maybe<AccrualPeriod>>>;
};

export type AddCheckIn = {
  __typename?: 'AddCheckIn';
  checkIn?: Maybe<CheckInType>;
  employee?: Maybe<EmployeeType>;
  error?: Maybe<Error>;
  ok?: Maybe<Scalars['Boolean']['output']>;
};

export type AddTimeOff = {
  __typename?: 'AddTimeOff';
  employee?: Maybe<EmployeeType>;
  entry?: Maybe<TimeOffEntryType>;
  error?: Maybe<Error>;
  ok?: Maybe<Scalars['Boolean']['output']>;
};

export type AdjustedWorkdayType = Node & {
  __typename?: 'AdjustedWorkdayType';
  holidayCalendar: HolidayCalendarType;
  holidayDate: Scalars['Date']['output'];
  holidayId: Scalars['IDInt']['output'];
  /** The ID of the object */
  id: Scalars['ID']['output'];
};

export type AdjustedWorkdayTypeConnection = {
  __typename?: 'AdjustedWorkdayTypeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<AdjustedWorkdayTypeEdge>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `AdjustedWorkdayType` and its cursor. */
export type AdjustedWorkdayTypeEdge = {
  __typename?: 'AdjustedWorkdayTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: AdjustedWorkdayType;
};

export type AdminGroupMembershipType = {
  __typename?: 'AdminGroupMembershipType';
  employee?: Maybe<EmployeeType>;
  memberships?: Maybe<Array<Maybe<AdminGroupRowType>>>;
};

export type AdminGroupRowType = {
  __typename?: 'AdminGroupRowType';
  groupPath?: Maybe<Array<Maybe<GroupType>>>;
  isOwner?: Maybe<Scalars['Boolean']['output']>;
  rootGroup?: Maybe<GroupType>;
};

export type AdminMembershipsType = {
  __typename?: 'AdminMembershipsType';
  securityListMemberships?: Maybe<Array<Maybe<AdminGroupMembershipType>>>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** An enumeration. */
export enum BalanceType {
  CheckWd = 'CHECK_WD',
  None = 'NONE',
  OwCalc = 'OW_CALC'
}

export type CancelSurvey = {
  __typename?: 'CancelSurvey';
  error?: Maybe<Error>;
  ok?: Maybe<Scalars['Boolean']['output']>;
};

export type CarryoverAdjustment = {
  __typename?: 'CarryoverAdjustment';
  amount?: Maybe<Scalars['Float']['output']>;
  expirationDate: Scalars['Date']['output'];
  year: Scalars['Int']['output'];
};

export type CategorySortObject = {
  id: Scalars['IDInt']['input'];
  products?: InputMaybe<Array<Scalars['IDInt']['input']>>;
};

/** An enumeration. */
export enum CheckInFormType {
  AdHoc = 'AD_HOC',
  Annual = 'ANNUAL',
  FollowUp = 'FOLLOW_UP',
  NewEmployee_1Month = 'NEW_EMPLOYEE_1_MONTH',
  NewEmployee_3Months = 'NEW_EMPLOYEE_3_MONTHS',
  NewEmployee_6Months = 'NEW_EMPLOYEE_6_MONTHS'
}

/** An enumeration. */
export enum CheckInFormat {
  ByZoom = 'BY_ZOOM',
  InPerson = 'IN_PERSON',
  OnPhone = 'ON_PHONE'
}

/** An enumeration. */
export enum CheckInStatus {
  Green = 'GREEN',
  Red = 'RED',
  Yellow = 'YELLOW'
}

export type CheckInType = Node & {
  __typename?: 'CheckInType';
  checkInId: Scalars['IDInt']['output'];
  /** A Base36 encoded ID for the check-in. */
  checkInIdBase36: Scalars['ID']['output'];
  company: CompanyType;
  createdDatetime?: Maybe<Scalars['DateTime']['output']>;
  displayDate?: Maybe<Scalars['Date']['output']>;
  dueDate?: Maybe<Scalars['Date']['output']>;
  employee: EmployeeType;
  employeeComment?: Maybe<Scalars['String']['output']>;
  employeeCommentDueDate?: Maybe<Scalars['Date']['output']>;
  employeeTitle: Scalars['String']['output'];
  engagement?: Maybe<OrgwikiCheckInEngagementChoices>;
  format?: Maybe<OrgwikiCheckInFormatChoices>;
  /** The ID of the object */
  id: Scalars['ID']['output'];
  manager: EmployeeType;
  managerComment?: Maybe<Scalars['String']['output']>;
  managerId: Scalars['IDInt']['output'];
  managerTitle: Scalars['String']['output'];
  modifiedDatetime?: Maybe<Scalars['DateTime']['output']>;
  reasonNotRequired?: Maybe<Scalars['String']['output']>;
  state: OrgwikiCheckInStateChoices;
  status?: Maybe<OrgwikiCheckInStatusChoices>;
  type: OrgwikiCheckInTypeChoices;
};

export type CheckInTypeConnection = {
  __typename?: 'CheckInTypeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<CheckInTypeEdge>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** A Relay edge containing a `CheckInType` and its cursor. */
export type CheckInTypeEdge = {
  __typename?: 'CheckInTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: CheckInType;
};

export type CheckInsSummaryType = {
  __typename?: 'CheckInsSummaryType';
  employee?: Maybe<EmployeeType>;
  engagementGreen?: Maybe<Scalars['Int']['output']>;
  engagementRed?: Maybe<Scalars['Int']['output']>;
  engagementYellow?: Maybe<Scalars['Int']['output']>;
  lastCheckIn?: Maybe<CheckInType>;
  overdue?: Maybe<Scalars['Int']['output']>;
  pending?: Maybe<Scalars['Int']['output']>;
  statusGreen?: Maybe<Scalars['Int']['output']>;
  statusRed?: Maybe<Scalars['Int']['output']>;
  statusYellow?: Maybe<Scalars['Int']['output']>;
  veryOverdue?: Maybe<Scalars['Int']['output']>;
};

export type CityType = Node & {
  __typename?: 'CityType';
  city: Scalars['String']['output'];
  country: Scalars['String']['output'];
  countryFlag: Scalars['String']['output'];
  /** The ID of the object */
  id: Scalars['ID']['output'];
  lat?: Maybe<Scalars['Float']['output']>;
  long?: Maybe<Scalars['Float']['output']>;
  state: Scalars['String']['output'];
};

export type CompanyConfigMutation = {
  __typename?: 'CompanyConfigMutation';
  companyConfig?: Maybe<CompanyConfigType>;
  error?: Maybe<Error>;
  ok?: Maybe<Scalars['Boolean']['output']>;
};

export type CompanyConfigType = Node & {
  __typename?: 'CompanyConfigType';
  aboutMarketsUrl?: Maybe<Scalars['String']['output']>;
  aboutProductsUrl?: Maybe<Scalars['String']['output']>;
  aboutRolesUrl?: Maybe<Scalars['String']['output']>;
  adminTagCreation?: Maybe<Scalars['Boolean']['output']>;
  areaEnabled: Scalars['Boolean']['output'];
  backgroundColor?: Maybe<Scalars['String']['output']>;
  companyLogo?: Maybe<Scalars['String']['output']>;
  companyLogoTitle?: Maybe<Scalars['String']['output']>;
  companyLogoUrl?: Maybe<Scalars['String']['output']>;
  highlightColor?: Maybe<Scalars['String']['output']>;
  homepageText?: Maybe<Scalars['String']['output']>;
  /** The ID of the object */
  id: Scalars['ID']['output'];
  lightBackground: Scalars['Boolean']['output'];
  lightNavbar: Scalars['Boolean']['output'];
  mobileHomepageMessage: Scalars['String']['output'];
  mobileHomepageText?: Maybe<Scalars['String']['output']>;
  navbarLogo?: Maybe<Scalars['String']['output']>;
  onboardingWizardEnabled?: Maybe<Scalars['Boolean']['output']>;
  primaryButtonColor?: Maybe<Scalars['String']['output']>;
  primaryColor?: Maybe<Scalars['String']['output']>;
  productOrder?: Maybe<Scalars['JSONString']['output']>;
};

export type CompanyMutation = {
  __typename?: 'CompanyMutation';
  company?: Maybe<CompanyType>;
  error?: Maybe<Error>;
  ok?: Maybe<Scalars['Boolean']['output']>;
};

export type CompanyType = Node & {
  __typename?: 'CompanyType';
  allowByIp?: Maybe<Scalars['Boolean']['output']>;
  allowCidrs?: Maybe<Scalars['String']['output']>;
  companyConfig?: Maybe<CompanyConfigType>;
  companyId?: Maybe<Scalars['IDInt']['output']>;
  employees: EmployeeTypeConnection;
  groups: GroupTypeConnection;
  holidayCalendars?: Maybe<HolidayCalendarConnection>;
  /** The ID of the object */
  id: Scalars['ID']['output'];
  markets: MarketTypeConnection;
  mentionObjectUrl?: Maybe<Scalars['String']['output']>;
  mentionTextName?: Maybe<Scalars['String']['output']>;
  pageInfo: PageInfo;
  productCategories: ProductCategoryTypeConnection;
  productCategoryGroupings: ProductCategoryGroupingTypeConnection;
  products: ProductTypeConnection;
  roleCategories: RoleCategoryTypeConnection;
  roles: RoleTypeConnection;
  sessionTimeout?: Maybe<Scalars['Int']['output']>;
};


export type CompanyTypeEmployeesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  publicId?: InputMaybe<Scalars['String']['input']>;
  timeOffEnabled?: InputMaybe<Scalars['Boolean']['input']>;
};


export type CompanyTypeGroupsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  subType?: InputMaybe<GroupsGroupSubTypeChoices>;
  type?: InputMaybe<GroupsGroupTypeChoices>;
};


export type CompanyTypeHolidayCalendarsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
};


export type CompanyTypeMarketsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
};


export type CompanyTypeProductCategoriesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type CompanyTypeProductCategoryGroupingsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type CompanyTypeProductsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type CompanyTypeRoleCategoriesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type CompanyTypeRolesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type CreateCustomer = {
  __typename?: 'CreateCustomer';
  customer?: Maybe<CustomerType>;
  errors: Array<ErrorType>;
  ok: Scalars['Boolean']['output'];
  vcOk?: Maybe<Scalars['Boolean']['output']>;
};

export type CreateProduct = {
  __typename?: 'CreateProduct';
  company?: Maybe<CompanyType>;
  error?: Maybe<Error>;
  ok?: Maybe<Scalars['Boolean']['output']>;
  product?: Maybe<ProductType>;
};

export type CreateProductCategory = {
  __typename?: 'CreateProductCategory';
  category?: Maybe<ProductCategoryType>;
  company?: Maybe<CompanyType>;
  error?: Maybe<Error>;
  ok?: Maybe<Scalars['Boolean']['output']>;
};

export type CreateProductCategoryGrouping = {
  __typename?: 'CreateProductCategoryGrouping';
  company?: Maybe<CompanyType>;
  error?: Maybe<Error>;
  grouping?: Maybe<ProductCategoryGroupingType>;
  ok?: Maybe<Scalars['Boolean']['output']>;
};

export type CreateRole = {
  __typename?: 'CreateRole';
  company?: Maybe<CompanyType>;
  error?: Maybe<Error>;
  ok?: Maybe<Scalars['Boolean']['output']>;
  role?: Maybe<RoleType>;
};

export type CreateRoleCategory = {
  __typename?: 'CreateRoleCategory';
  category?: Maybe<RoleCategoryType>;
  company?: Maybe<CompanyType>;
  error?: Maybe<Error>;
  ok?: Maybe<Scalars['Boolean']['output']>;
};

export type CreateSurvey = {
  __typename?: 'CreateSurvey';
  error?: Maybe<Error>;
  ok?: Maybe<Scalars['Boolean']['output']>;
  survey?: Maybe<SurveyType>;
};

export type CustomSectionDataType = Node & {
  __typename?: 'CustomSectionDataType';
  active: Scalars['Boolean']['output'];
  customSection: CustomSectionType;
  /** The ID of the object */
  id: Scalars['ID']['output'];
  lastUpdated?: Maybe<Scalars['DateTime']['output']>;
  mentions?: Maybe<Array<Maybe<MentionType>>>;
  text: Scalars['String']['output'];
};

export type CustomSectionDataTypeConnection = {
  __typename?: 'CustomSectionDataTypeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<CustomSectionDataTypeEdge>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `CustomSectionDataType` and its cursor. */
export type CustomSectionDataTypeEdge = {
  __typename?: 'CustomSectionDataTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: CustomSectionDataType;
};

export type CustomSectionType = Node & {
  __typename?: 'CustomSectionType';
  activeByDefault: Scalars['Boolean']['output'];
  /** The ID of the object */
  id: Scalars['ID']['output'];
  intendedFor: Scalars['String']['output'];
  sectionType: Scalars['String']['output'];
  sortOrder: Scalars['Int']['output'];
  title: Scalars['String']['output'];
  type: OrgwikiCustomSectionTypeChoices;
  updateInterval: OrgwikiCustomSectionUpdateIntervalChoices;
};

export type CustomerInputType = {
  customerId: Scalars['IDInt']['input'];
  isAccountLead?: InputMaybe<Scalars['Boolean']['input']>;
  isAccountPartner?: InputMaybe<Scalars['Boolean']['input']>;
  isCommercialLead?: InputMaybe<Scalars['Boolean']['input']>;
  isExecutiveSponsor?: InputMaybe<Scalars['Boolean']['input']>;
  isRdLead?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CustomerTeamMemberType = Node & {
  __typename?: 'CustomerTeamMemberType';
  customer: CustomerType;
  customerId: Scalars['IDInt']['output'];
  employee: EmployeeType;
  employeeId: Scalars['IDInt']['output'];
  /** The ID of the object */
  id: Scalars['ID']['output'];
  isAccountLead: Scalars['Boolean']['output'];
  isAccountPartner: Scalars['Boolean']['output'];
  isCommercialLead: Scalars['Boolean']['output'];
  isExecutiveSponsor: Scalars['Boolean']['output'];
  isRdLead: Scalars['Boolean']['output'];
};

export type CustomerTeamMemberTypeConnection = {
  __typename?: 'CustomerTeamMemberTypeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<CustomerTeamMemberTypeEdge>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** A Relay edge containing a `CustomerTeamMemberType` and its cursor. */
export type CustomerTeamMemberTypeEdge = {
  __typename?: 'CustomerTeamMemberTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: CustomerTeamMemberType;
};

export type CustomerType = Node & {
  __typename?: 'CustomerType';
  aliases?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  appstatsId?: Maybe<Scalars['Int']['output']>;
  company: CompanyType;
  createdDatetime?: Maybe<Scalars['DateTime']['output']>;
  customerId: Scalars['IDInt']['output'];
  domains?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** The ID of the object */
  id: Scalars['ID']['output'];
  isActive: Scalars['Boolean']['output'];
  isProspect: Scalars['Boolean']['output'];
  isRestricted?: Maybe<Scalars['Boolean']['output']>;
  logo?: Maybe<Scalars['String']['output']>;
  memberCount: Scalars['Int']['output'];
  members: CustomerTeamMemberTypeConnection;
  modifiedDatetime?: Maybe<Scalars['DateTime']['output']>;
  name: Scalars['String']['output'];
  pronunciationUrl?: Maybe<Scalars['String']['output']>;
  vcId?: Maybe<Scalars['String']['output']>;
};


export type CustomerTypeMembersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  customerId?: InputMaybe<Scalars['ID']['input']>;
  employeeId?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  isLead?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
};

export type CustomerTypeConnection = {
  __typename?: 'CustomerTypeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<CustomerTypeEdge>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** A Relay edge containing a `CustomerType` and its cursor. */
export type CustomerTypeEdge = {
  __typename?: 'CustomerTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: CustomerType;
};

/** An enumeration. */
export enum DayLengthType {
  AllDay = 'ALL_DAY',
  Am = 'AM',
  Half = 'HALF',
  Pm = 'PM'
}

export type DeleteCheckIn = {
  __typename?: 'DeleteCheckIn';
  checkIn?: Maybe<CheckInType>;
  employee?: Maybe<EmployeeType>;
  error?: Maybe<Error>;
  ok?: Maybe<Scalars['Boolean']['output']>;
};

export type DeleteProduct = {
  __typename?: 'DeleteProduct';
  company?: Maybe<CompanyType>;
  error?: Maybe<Error>;
  ok?: Maybe<Scalars['Boolean']['output']>;
};

export type DeleteProductCategory = {
  __typename?: 'DeleteProductCategory';
  company?: Maybe<CompanyType>;
  error?: Maybe<Error>;
  ok?: Maybe<Scalars['Boolean']['output']>;
};

export type DeleteProductCategoryGrouping = {
  __typename?: 'DeleteProductCategoryGrouping';
  company?: Maybe<CompanyType>;
  error?: Maybe<Error>;
  ok?: Maybe<Scalars['Boolean']['output']>;
};

export type DeleteRole = {
  __typename?: 'DeleteRole';
  company?: Maybe<CompanyType>;
  error?: Maybe<Error>;
  ok?: Maybe<Scalars['Boolean']['output']>;
};

export type DeleteRoleCategory = {
  __typename?: 'DeleteRoleCategory';
  company?: Maybe<CompanyType>;
  error?: Maybe<Error>;
  ok?: Maybe<Scalars['Boolean']['output']>;
};

export type DeleteSurveyReportNotification = {
  __typename?: 'DeleteSurveyReportNotification';
  error?: Maybe<Error>;
  ok?: Maybe<Scalars['Boolean']['output']>;
};

export type DeleteTimeOff = {
  __typename?: 'DeleteTimeOff';
  employee?: Maybe<EmployeeType>;
  entry?: Maybe<TimeOffEntryType>;
  error?: Maybe<Error>;
  ok?: Maybe<Scalars['Boolean']['output']>;
};

export type DomainValidator = {
  __typename?: 'DomainValidator';
  domain: Scalars['String']['output'];
  error?: Maybe<Error>;
  ok: Scalars['Boolean']['output'];
};

export type EditCheckIn = {
  __typename?: 'EditCheckIn';
  checkIn?: Maybe<CheckInType>;
  employee?: Maybe<EmployeeType>;
  error?: Maybe<Error>;
  ok?: Maybe<Scalars['Boolean']['output']>;
};

export type EditCustomer = {
  __typename?: 'EditCustomer';
  customer?: Maybe<CustomerType>;
  errors: Array<ErrorType>;
  ok: Scalars['Boolean']['output'];
  vcOk?: Maybe<Scalars['Boolean']['output']>;
};

export type EditProduct = {
  __typename?: 'EditProduct';
  company?: Maybe<CompanyType>;
  error?: Maybe<Error>;
  ok?: Maybe<Scalars['Boolean']['output']>;
  product?: Maybe<ProductType>;
};

export type EditProductCategory = {
  __typename?: 'EditProductCategory';
  category?: Maybe<ProductCategoryType>;
  company?: Maybe<CompanyType>;
  error?: Maybe<Error>;
  ok?: Maybe<Scalars['Boolean']['output']>;
};

export type EditProductCategoryGrouping = {
  __typename?: 'EditProductCategoryGrouping';
  company?: Maybe<CompanyType>;
  error?: Maybe<Error>;
  grouping?: Maybe<ProductCategoryGroupingType>;
  ok?: Maybe<Scalars['Boolean']['output']>;
};

export type EditRole = {
  __typename?: 'EditRole';
  company?: Maybe<CompanyType>;
  error?: Maybe<Error>;
  ok?: Maybe<Scalars['Boolean']['output']>;
  role?: Maybe<RoleType>;
};

export type EditRoleCategory = {
  __typename?: 'EditRoleCategory';
  category?: Maybe<RoleCategoryType>;
  company?: Maybe<CompanyType>;
  error?: Maybe<Error>;
  ok?: Maybe<Scalars['Boolean']['output']>;
};

export type EditTimeOff = {
  __typename?: 'EditTimeOff';
  employee?: Maybe<EmployeeType>;
  entry?: Maybe<TimeOffEntryType>;
  error?: Maybe<Error>;
  ok?: Maybe<Scalars['Boolean']['output']>;
};

export type EmployeeTagType = Node & {
  __typename?: 'EmployeeTagType';
  employee: EmployeeType;
  /** The ID of the object */
  id: Scalars['ID']['output'];
  skillLevel: Scalars['Int']['output'];
  tag: TagType;
};

export type EmployeeTagTypeConnection = {
  __typename?: 'EmployeeTagTypeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<EmployeeTagTypeEdge>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `EmployeeTagType` and its cursor. */
export type EmployeeTagTypeEdge = {
  __typename?: 'EmployeeTagTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: EmployeeTagType;
};

export type EmployeeType = Node & {
  __typename?: 'EmployeeType';
  additionalContactMethods: Scalars['String']['output'];
  adminModeEnabled: Scalars['Boolean']['output'];
  allowProfileEdits?: Maybe<Scalars['Boolean']['output']>;
  authUserCanSeeSick?: Maybe<Scalars['Boolean']['output']>;
  availableTeamCalendars?: Maybe<Array<Maybe<GoogleCalendarType>>>;
  balloons: Scalars['Boolean']['output'];
  canCreateCompanyMentions: Scalars['Boolean']['output'];
  canEditDesk?: Maybe<Scalars['Boolean']['output']>;
  checkIns: CheckInTypeConnection;
  customSectionDatas: CustomSectionDataTypeConnection;
  customers: CustomerTeamMemberTypeConnection;
  descendantsCount?: Maybe<Scalars['Int']['output']>;
  directReports: EmployeeTypeConnection;
  directReportsCount?: Maybe<Scalars['Int']['output']>;
  dlistsCount?: Maybe<Scalars['Int']['output']>;
  dottedLineManagers: EmployeeTypeConnection;
  dottedLineReports: EmployeeTypeConnection;
  email: Scalars['String']['output'];
  employeeId: Scalars['IDInt']['output'];
  employmentDuration?: Maybe<EmploymentDurationType>;
  externalId: Scalars['String']['output'];
  firstName: Scalars['String']['output'];
  fullName: Scalars['String']['output'];
  groups: GroupMemberTypeConnection;
  hideFlashcardScore?: Maybe<Scalars['Boolean']['output']>;
  hideSensitiveContactInfo?: Maybe<Scalars['Boolean']['output']>;
  holidayCalendar?: Maybe<HolidayCalendarType>;
  homeCity?: Maybe<CityType>;
  /** The ID of the object */
  id: Scalars['ID']['output'];
  isActive: Scalars['Boolean']['output'];
  isAdmin: Scalars['Boolean']['output'];
  isBoardOfDirectors?: Maybe<Scalars['Boolean']['output']>;
  isContractor: Scalars['Boolean']['output'];
  isEarlyAdopter?: Maybe<Scalars['Boolean']['output']>;
  lastAlternateContact?: Maybe<EmployeeType>;
  lastAutoDecline?: Maybe<TimeOffAutoDeclineType>;
  lastName: Scalars['String']['output'];
  lastOnlySendContacts?: Maybe<Scalars['Boolean']['output']>;
  lastOnlySendInternal?: Maybe<Scalars['Boolean']['output']>;
  lastTeamCalendar?: Maybe<Scalars['String']['output']>;
  lineage?: Maybe<Scalars['String']['output']>;
  linkedinUrl: Scalars['String']['output'];
  manager?: Maybe<EmployeeType>;
  market?: Maybe<Scalars['String']['output']>;
  mattermostTeam?: Maybe<Scalars['String']['output']>;
  mattermostUsername?: Maybe<Scalars['String']['output']>;
  maxAddTimeOffDate?: Maybe<Scalars['Date']['output']>;
  mentionObjectUrl?: Maybe<Scalars['String']['output']>;
  mentionTextName?: Maybe<Scalars['String']['output']>;
  mobilePhone: Scalars['String']['output'];
  nickName: Scalars['String']['output'];
  officePhone: Scalars['String']['output'];
  preferredConferencing?: Maybe<OrgwikiEmployeePreferredConferencingChoices>;
  preferredMessaging?: Maybe<OrgwikiEmployeePreferredMessagingChoices>;
  priorCompanyName: Scalars['String']['output'];
  priorStartDate?: Maybe<Scalars['Date']['output']>;
  profileLastUpdated?: Maybe<Scalars['DateTime']['output']>;
  profilePhoto?: Maybe<Scalars['String']['output']>;
  profilePhotoThumbnail?: Maybe<Scalars['String']['output']>;
  profileStrength?: Maybe<Scalars['Int']['output']>;
  pronunciationUrl?: Maybe<Scalars['String']['output']>;
  provisionedManager?: Maybe<Scalars['String']['output']>;
  ptoPeriodStartDate?: Maybe<Scalars['Date']['output']>;
  publicId: Scalars['String']['output'];
  remiUrl?: Maybe<Scalars['String']['output']>;
  role?: Maybe<RoleType>;
  showBothCounts?: Maybe<Scalars['Boolean']['output']>;
  showDirectReportsCount?: Maybe<Scalars['Boolean']['output']>;
  showJuryDuty?: Maybe<Scalars['Boolean']['output']>;
  showSickType?: Maybe<Scalars['Boolean']['output']>;
  showTimeOff?: Maybe<Scalars['Boolean']['output']>;
  skypeBusinessAddress: Scalars['String']['output'];
  skypeName: Scalars['String']['output'];
  slackName?: Maybe<Scalars['String']['output']>;
  slackTeam?: Maybe<Scalars['String']['output']>;
  startDate?: Maybe<Scalars['Date']['output']>;
  surveyReports: SurveyReportsTypeConnection;
  tags: EmployeeTagTypeConnection;
  teamCheckInsSummaries?: Maybe<Array<Maybe<CheckInsSummaryType>>>;
  timeOffEntries: TimeOffEntryTypeConnection;
  timeOffTimezone?: Maybe<Scalars['String']['output']>;
  timeOffTotals?: Maybe<TimeOffTotalType>;
  timezoneName: Scalars['String']['output'];
  timezoneOffset: Scalars['Int']['output'];
  title: Scalars['String']['output'];
  transferDescription?: Maybe<Scalars['String']['output']>;
  transferEntryPending: Scalars['Boolean']['output'];
  transferLastUpdated?: Maybe<Scalars['DateTime']['output']>;
  wdRefId?: Maybe<Scalars['String']['output']>;
  webex: Scalars['String']['output'];
  zoomUrl?: Maybe<Scalars['String']['output']>;
};


export type EmployeeTypeCheckInsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
};


export type EmployeeTypeCustomSectionDatasArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type EmployeeTypeCustomersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  customerId?: InputMaybe<Scalars['ID']['input']>;
  employeeId?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  isLead?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
};


export type EmployeeTypeDirectReportsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  publicId?: InputMaybe<Scalars['String']['input']>;
  timeOffEnabled?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EmployeeTypeDottedLineManagersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  publicId?: InputMaybe<Scalars['String']['input']>;
  timeOffEnabled?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EmployeeTypeDottedLineReportsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  publicId?: InputMaybe<Scalars['String']['input']>;
  timeOffEnabled?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EmployeeTypeGroupsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  group_Type?: InputMaybe<GroupsGroupTypeChoices>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type EmployeeTypeSurveyReportsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<ReportType>;
};


export type EmployeeTypeTagsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type EmployeeTypeTimeOffEntriesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  allowPreviousYear?: InputMaybe<Scalars['Boolean']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  year?: InputMaybe<Scalars['Decimal']['input']>;
};

export type EmployeeTypeConnection = {
  __typename?: 'EmployeeTypeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<EmployeeTypeEdge>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `EmployeeType` and its cursor. */
export type EmployeeTypeEdge = {
  __typename?: 'EmployeeTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: EmployeeType;
};

export type EmploymentDurationType = {
  __typename?: 'EmploymentDurationType';
  humanFriendly?: Maybe<Scalars['String']['output']>;
  months?: Maybe<Scalars['Int']['output']>;
  years?: Maybe<Scalars['Int']['output']>;
};

export type Error = {
  __typename?: 'Error';
  code?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
};

export type ErrorType = {
  __typename?: 'ErrorType';
  field: Scalars['String']['output'];
  messages: Array<Scalars['String']['output']>;
};

export type GoogleCalendarType = {
  __typename?: 'GoogleCalendarType';
  googleId?: Maybe<Scalars['String']['output']>;
  summary?: Maybe<Scalars['String']['output']>;
};

export type GroupMemberType = Node & {
  __typename?: 'GroupMemberType';
  group: GroupType;
  /** The ID of the object */
  id: Scalars['ID']['output'];
  isActive: Scalars['Boolean']['output'];
  lastVisit?: Maybe<Scalars['DateTime']['output']>;
  nestedGroup?: Maybe<GroupType>;
  person?: Maybe<EmployeeType>;
};

export type GroupMemberTypeConnection = {
  __typename?: 'GroupMemberTypeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<GroupMemberTypeEdge>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `GroupMemberType` and its cursor. */
export type GroupMemberTypeEdge = {
  __typename?: 'GroupMemberTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: GroupMemberType;
};

export type GroupType = Node & {
  __typename?: 'GroupType';
  activeMemberCount?: Maybe<Scalars['Int']['output']>;
  city?: Maybe<CityType>;
  description: Scalars['String']['output'];
  email?: Maybe<Scalars['String']['output']>;
  hideEmailMembers?: Maybe<Scalars['Boolean']['output']>;
  /** The ID of the object */
  id: Scalars['ID']['output'];
  inviteOnly: Scalars['Boolean']['output'];
  isActive: Scalars['Boolean']['output'];
  isFlat: Scalars['Boolean']['output'];
  isLocked: Scalars['Boolean']['output'];
  isPrivate: Scalars['Boolean']['output'];
  isReadOnly: Scalars['Boolean']['output'];
  isUtilityGroup?: Maybe<Scalars['Boolean']['output']>;
  membersOnlySocial?: Maybe<Scalars['Boolean']['output']>;
  mentionObjectUrl?: Maybe<Scalars['String']['output']>;
  mentionTextName?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  overviewEnabled: Scalars['Boolean']['output'];
  overviewText: Scalars['String']['output'];
  owners: EmployeeTypeConnection;
  photo?: Maybe<Scalars['String']['output']>;
  providerGroupType?: Maybe<Scalars['String']['output']>;
  slugName: Scalars['String']['output'];
  subType: GroupsGroupSubTypeChoices;
  type: GroupsGroupTypeChoices;
  whoCanPost?: Maybe<GroupsGroupWhoCanPostChoices>;
};


export type GroupTypeOwnersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  publicId?: InputMaybe<Scalars['String']['input']>;
  timeOffEnabled?: InputMaybe<Scalars['Boolean']['input']>;
};

export type GroupTypeConnection = {
  __typename?: 'GroupTypeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<GroupTypeEdge>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `GroupType` and its cursor. */
export type GroupTypeEdge = {
  __typename?: 'GroupTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: GroupType;
};

/** An enumeration. */
export enum GroupsGroupSubTypeChoices {
  /** Auto Distribution List */
  AutoDlist = 'AUTO_DLIST',
  /** Custom Distribution List */
  CustomDlist = 'CUSTOM_DLIST',
  /** In Memoriam Group */
  InMemoriam = 'IN_MEMORIAM',
  /** Local Community */
  Local = 'LOCAL',
  /** Security Distribution List */
  SecurityDlist = 'SECURITY_DLIST',
  /** Social Group */
  Social = 'SOCIAL'
}

/** An enumeration. */
export enum GroupsGroupTypeChoices {
  /** Community Group */
  Community = 'COMMUNITY',
  /** Distribution List */
  DistributionList = 'DISTRIBUTION_LIST'
}

/** An enumeration. */
export enum GroupsGroupWhoCanPostChoices {
  /** domain */
  A_1 = 'A_1',
  /** anyone */
  A_2 = 'A_2'
}

export type HolidayCalendarConnection = {
  __typename?: 'HolidayCalendarConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<HolidayCalendarEdge>>;
  extra?: Maybe<Scalars['String']['output']>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `HolidayCalendar` and its cursor. */
export type HolidayCalendarEdge = {
  __typename?: 'HolidayCalendarEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<HolidayCalendarType>;
  other?: Maybe<Scalars['String']['output']>;
};

export type HolidayCalendarType = Node & {
  __typename?: 'HolidayCalendarType';
  adjustedworkdays: AdjustedWorkdayTypeConnection;
  allocationType?: Maybe<PtoAllocationType>;
  balanceType?: Maybe<BalanceType>;
  companyId: Scalars['IDInt']['output'];
  holidayCalendarId: Scalars['IDInt']['output'];
  holidays: HolidayTypeConnection;
  /** The ID of the object */
  id: Scalars['ID']['output'];
  otherHintText?: Maybe<Scalars['String']['output']>;
  ptoHintText?: Maybe<Scalars['String']['output']>;
  sickHintText?: Maybe<Scalars['String']['output']>;
  wdRefId: Scalars['String']['output'];
};


export type HolidayCalendarTypeAdjustedworkdaysArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type HolidayCalendarTypeHolidaysArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type HolidayType = Node & {
  __typename?: 'HolidayType';
  half: Scalars['Boolean']['output'];
  holidayCalendar: HolidayCalendarType;
  holidayDate: Scalars['Date']['output'];
  holidayId: Scalars['IDInt']['output'];
  /** The ID of the object */
  id: Scalars['ID']['output'];
};

export type HolidayTypeConnection = {
  __typename?: 'HolidayTypeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<HolidayTypeEdge>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `HolidayType` and its cursor. */
export type HolidayTypeEdge = {
  __typename?: 'HolidayTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: HolidayType;
};

export type MarketType = Node & {
  __typename?: 'MarketType';
  company: CompanyType;
  count: Scalars['Int']['output'];
  employees: EmployeeTypeConnection;
  /** The ID of the object */
  id: Scalars['ID']['output'];
  marketId: Scalars['IDInt']['output'];
  name: Scalars['String']['output'];
};


export type MarketTypeEmployeesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  publicId?: InputMaybe<Scalars['String']['input']>;
  timeOffEnabled?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MarketTypeConnection = {
  __typename?: 'MarketTypeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<MarketTypeEdge>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** A Relay edge containing a `MarketType` and its cursor. */
export type MarketTypeEdge = {
  __typename?: 'MarketTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: MarketType;
};

export type MentionType = Node & {
  __typename?: 'MentionType';
  /** The ID of the object */
  id: Scalars['ID']['output'];
  mention?: Maybe<MentionableType>;
  order?: Maybe<Scalars['Int']['output']>;
};

export type MentionableType = CompanyType | EmployeeType | GroupType;

export type MoveCategory = {
  __typename?: 'MoveCategory';
  company?: Maybe<CompanyType>;
  error?: Maybe<Error>;
  ok?: Maybe<Scalars['Boolean']['output']>;
};

export type MoveProduct = {
  __typename?: 'MoveProduct';
  company?: Maybe<CompanyType>;
  error?: Maybe<Error>;
  ok?: Maybe<Scalars['Boolean']['output']>;
};

export type Mutation = {
  __typename?: 'Mutation';
  addCheckIn?: Maybe<AddCheckIn>;
  addTimeOff?: Maybe<AddTimeOff>;
  cancelSurvey?: Maybe<CancelSurvey>;
  createCustomer?: Maybe<CreateCustomer>;
  createProduct?: Maybe<CreateProduct>;
  createProductCategory?: Maybe<CreateProductCategory>;
  createProductCategoryGrouping?: Maybe<CreateProductCategoryGrouping>;
  createRole?: Maybe<CreateRole>;
  createRoleCategory?: Maybe<CreateRoleCategory>;
  createSurvey?: Maybe<CreateSurvey>;
  deleteCheckIn?: Maybe<DeleteCheckIn>;
  deleteProduct?: Maybe<DeleteProduct>;
  deleteProductCategory?: Maybe<DeleteProductCategory>;
  deleteProductCategoryGrouping?: Maybe<DeleteProductCategoryGrouping>;
  deleteRole?: Maybe<DeleteRole>;
  deleteRoleCategory?: Maybe<DeleteRoleCategory>;
  deleteSurveyReportNotification?: Maybe<DeleteSurveyReportNotification>;
  deleteTimeOff?: Maybe<DeleteTimeOff>;
  editCheckIn?: Maybe<EditCheckIn>;
  editCustomer?: Maybe<EditCustomer>;
  editProduct?: Maybe<EditProduct>;
  editProductCategory?: Maybe<EditProductCategory>;
  editProductCategoryGrouping?: Maybe<EditProductCategoryGrouping>;
  editRole?: Maybe<EditRole>;
  editRoleCategory?: Maybe<EditRoleCategory>;
  editTimeOff?: Maybe<EditTimeOff>;
  moveCategory?: Maybe<MoveCategory>;
  moveProduct?: Maybe<MoveProduct>;
  publishSurveyResults?: Maybe<PublishSurveyResults>;
  saveSearch?: Maybe<SaveSearch>;
  setCompany?: Maybe<CompanyMutation>;
  setCompanyConfig?: Maybe<CompanyConfigMutation>;
  setEmployeeCustomers?: Maybe<SetEmployeeCustomers>;
  setHomepageText?: Maybe<SetHomepageText>;
  setProductOrder?: Maybe<SetProductOrder>;
};


export type MutationAddCheckInArgs = {
  checkInFormat: CheckInFormat;
  checkInType: CheckInFormType;
  employeeId: Scalars['IDInt']['input'];
  engagement: CheckInStatus;
  managerComment?: InputMaybe<Scalars['String']['input']>;
  managerId: Scalars['IDInt']['input'];
  status: CheckInStatus;
};


export type MutationAddTimeOffArgs = {
  alternateContact?: InputMaybe<Scalars['IDInt']['input']>;
  autoDecline: TimeOffAutoDeclineType;
  autoResponseBody?: InputMaybe<Scalars['String']['input']>;
  autoResponseSubject?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  employeeId: Scalars['IDInt']['input'];
  endDate?: InputMaybe<Scalars['Date']['input']>;
  endDayLength?: InputMaybe<DayLengthType>;
  onlySendContacts?: InputMaybe<Scalars['Boolean']['input']>;
  onlySendInternal?: InputMaybe<Scalars['Boolean']['input']>;
  otherDescription?: InputMaybe<Scalars['String']['input']>;
  startDate: Scalars['Date']['input'];
  startDayLength: DayLengthType;
  teamCalendarId?: InputMaybe<Scalars['String']['input']>;
  timeOffType: TimeOffType;
};


export type MutationCancelSurveyArgs = {
  surveyId: Scalars['IDInt']['input'];
};


export type MutationCreateCustomerArgs = {
  addToVc?: InputMaybe<Scalars['Boolean']['input']>;
  aliases?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  appstatsId?: InputMaybe<Scalars['Int']['input']>;
  domains?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isProspect?: InputMaybe<Scalars['Boolean']['input']>;
  isRestricted?: InputMaybe<Scalars['Boolean']['input']>;
  logo?: InputMaybe<Scalars['Upload']['input']>;
  name: Scalars['String']['input'];
};


export type MutationCreateProductArgs = {
  categoryId: Scalars['IDInt']['input'];
  name: Scalars['String']['input'];
};


export type MutationCreateProductCategoryArgs = {
  groupingId?: InputMaybe<Scalars['IDInt']['input']>;
  hidden?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
};


export type MutationCreateProductCategoryGroupingArgs = {
  name: Scalars['String']['input'];
};


export type MutationCreateRoleArgs = {
  categoryId: Scalars['IDInt']['input'];
  name: Scalars['String']['input'];
};


export type MutationCreateRoleCategoryArgs = {
  name: Scalars['String']['input'];
};


export type MutationCreateSurveyArgs = {
  endTime: Scalars['DateTime']['input'];
  firstReminderTime?: InputMaybe<Scalars['DateTime']['input']>;
  isFull: Scalars['Boolean']['input'];
  managerIds?: InputMaybe<Array<InputMaybe<Scalars['IDInt']['input']>>>;
  secondReminderTime?: InputMaybe<Scalars['DateTime']['input']>;
  startTime: Scalars['DateTime']['input'];
  title: Scalars['String']['input'];
};


export type MutationDeleteCheckInArgs = {
  checkInId: Scalars['IDInt']['input'];
};


export type MutationDeleteProductArgs = {
  force?: InputMaybe<Scalars['Boolean']['input']>;
  productId: Scalars['IDInt']['input'];
};


export type MutationDeleteProductCategoryArgs = {
  categoryId: Scalars['IDInt']['input'];
};


export type MutationDeleteProductCategoryGroupingArgs = {
  groupingId: Scalars['IDInt']['input'];
};


export type MutationDeleteRoleArgs = {
  force?: InputMaybe<Scalars['Boolean']['input']>;
  roleId: Scalars['IDInt']['input'];
};


export type MutationDeleteRoleCategoryArgs = {
  categoryId: Scalars['IDInt']['input'];
};


export type MutationDeleteSurveyReportNotificationArgs = {
  surveyReportId: Scalars['IDInt']['input'];
};


export type MutationDeleteTimeOffArgs = {
  entryId: Scalars['IDInt']['input'];
};


export type MutationEditCheckInArgs = {
  checkInFormat?: InputMaybe<CheckInFormat>;
  checkInId: Scalars['IDInt']['input'];
  checkInType: CheckInFormType;
  employeeComment?: InputMaybe<Scalars['String']['input']>;
  employeeId: Scalars['IDInt']['input'];
  engagement?: InputMaybe<CheckInStatus>;
  managerComment?: InputMaybe<Scalars['String']['input']>;
  managerId: Scalars['IDInt']['input'];
  reasonNotRequired?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<CheckInStatus>;
};


export type MutationEditCustomerArgs = {
  addToVc?: InputMaybe<Scalars['Boolean']['input']>;
  aliases?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  appstatsId?: InputMaybe<Scalars['Int']['input']>;
  customerId: Scalars['IDInt']['input'];
  domains?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isProspect?: InputMaybe<Scalars['Boolean']['input']>;
  isRestricted?: InputMaybe<Scalars['Boolean']['input']>;
  logo?: InputMaybe<Scalars['Upload']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};


export type MutationEditProductArgs = {
  name: Scalars['String']['input'];
  productId: Scalars['IDInt']['input'];
};


export type MutationEditProductCategoryArgs = {
  categoryId: Scalars['IDInt']['input'];
  hidden?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
};


export type MutationEditProductCategoryGroupingArgs = {
  groupingId: Scalars['IDInt']['input'];
  name: Scalars['String']['input'];
};


export type MutationEditRoleArgs = {
  categoryId?: InputMaybe<Scalars['IDInt']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  roleId: Scalars['IDInt']['input'];
};


export type MutationEditRoleCategoryArgs = {
  categoryId: Scalars['IDInt']['input'];
  name: Scalars['String']['input'];
};


export type MutationEditTimeOffArgs = {
  alternateContact?: InputMaybe<Scalars['IDInt']['input']>;
  autoDecline: TimeOffAutoDeclineType;
  autoResponseBody?: InputMaybe<Scalars['String']['input']>;
  autoResponseSubject?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['Date']['input']>;
  endDayLength?: InputMaybe<DayLengthType>;
  entryId: Scalars['IDInt']['input'];
  onlySendContacts?: InputMaybe<Scalars['Boolean']['input']>;
  onlySendInternal?: InputMaybe<Scalars['Boolean']['input']>;
  startDate: Scalars['Date']['input'];
  startDayLength: DayLengthType;
  teamCalendarId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationMoveCategoryArgs = {
  categoryId: Scalars['IDInt']['input'];
  groupingId?: InputMaybe<Scalars['IDInt']['input']>;
  newOrder: Array<InputMaybe<SortObject>>;
};


export type MutationMoveProductArgs = {
  categoryId: Scalars['IDInt']['input'];
  newOrder: Array<InputMaybe<SortObject>>;
  productId: Scalars['IDInt']['input'];
};


export type MutationPublishSurveyResultsArgs = {
  managerId?: InputMaybe<Scalars['IDInt']['input']>;
  stage?: InputMaybe<PublishStage>;
  surveyId: Scalars['IDInt']['input'];
};


export type MutationSaveSearchArgs = {
  blob: Scalars['JSONString']['input'];
};


export type MutationSetCompanyArgs = {
  allowByIp?: InputMaybe<Scalars['Boolean']['input']>;
  allowCidrs?: InputMaybe<Scalars['String']['input']>;
  sessionTimeout?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationSetCompanyConfigArgs = {
  adminTagCreation?: InputMaybe<Scalars['String']['input']>;
  backgroundColor?: InputMaybe<Scalars['String']['input']>;
  companyLogo?: InputMaybe<Scalars['Upload']['input']>;
  companyLogoTitle?: InputMaybe<Scalars['String']['input']>;
  companyLogoUrl?: InputMaybe<Scalars['String']['input']>;
  highlightColor?: InputMaybe<Scalars['String']['input']>;
  lightBackground?: InputMaybe<Scalars['Boolean']['input']>;
  lightNavbar?: InputMaybe<Scalars['Boolean']['input']>;
  navbarLogo?: InputMaybe<Scalars['Upload']['input']>;
  onboardingWizardEnabled?: InputMaybe<Scalars['String']['input']>;
  primaryButtonColor?: InputMaybe<Scalars['String']['input']>;
  primaryColor?: InputMaybe<Scalars['String']['input']>;
};


export type MutationSetEmployeeCustomersArgs = {
  employeeId: Scalars['IDInt']['input'];
  members: Array<InputMaybe<CustomerInputType>>;
};


export type MutationSetHomepageTextArgs = {
  homepageText?: InputMaybe<Scalars['String']['input']>;
  mobileHomepageMessage?: InputMaybe<Scalars['String']['input']>;
  mobileHomepageText?: InputMaybe<Scalars['String']['input']>;
};


export type MutationSetProductOrderArgs = {
  newOrder: Array<InputMaybe<SortObject>>;
};

/** An object with an ID */
export type Node = {
  /** The ID of the object */
  id: Scalars['ID']['output'];
};

/** An enumeration. */
export enum OrgwikiCheckInEngagementChoices {
  /** Green */
  Green = 'GREEN',
  /** Red */
  Red = 'RED',
  /** Yellow */
  Yellow = 'YELLOW'
}

/** An enumeration. */
export enum OrgwikiCheckInFormatChoices {
  /** By Zoom */
  ByZoom = 'BY_ZOOM',
  /** In Person */
  InPerson = 'IN_PERSON',
  /** On Phone */
  OnPhone = 'ON_PHONE'
}

/** An enumeration. */
export enum OrgwikiCheckInStateChoices {
  /** Archived */
  Archived = 'ARCHIVED',
  /** Check In Due */
  CheckInDue = 'CHECK_IN_DUE',
  /** Comments Due */
  CommentsDue = 'COMMENTS_DUE',
  /** Complete */
  Complete = 'COMPLETE',
  /** Deleted */
  Deleted = 'DELETED',
  /** Not Required */
  NotRequired = 'NOT_REQUIRED'
}

/** An enumeration. */
export enum OrgwikiCheckInStatusChoices {
  /** Green */
  Green = 'GREEN',
  /** Red */
  Red = 'RED',
  /** Yellow */
  Yellow = 'YELLOW'
}

/** An enumeration. */
export enum OrgwikiCheckInTypeChoices {
  /** adHoc */
  AdHoc = 'AD_HOC',
  /** annual */
  Annual = 'ANNUAL',
  /** followUp */
  FollowUp = 'FOLLOW_UP',
  /** newEmployee1Month */
  NewEmployee_1Month = 'NEW_EMPLOYEE_1_MONTH',
  /** newEmployee3Month */
  NewEmployee_3Months = 'NEW_EMPLOYEE_3_MONTHS',
  /** newEmployee6Month */
  NewEmployee_6Months = 'NEW_EMPLOYEE_6_MONTHS'
}

/** An enumeration. */
export enum OrgwikiCustomSectionTypeChoices {
  /** About */
  A_1 = 'A_1',
  /** Responsibilities */
  A_2 = 'A_2',
  /** What am I doing this quarter */
  A_3 = 'A_3',
  /** Projects - Past and Present */
  A_4 = 'A_4',
  /** Key Accounts */
  A_5 = 'A_5',
  /** Custom */
  A_6 = 'A_6',
  /** In Memoriam */
  A_7 = 'A_7',
  /** Customer */
  A_8 = 'A_8'
}

/** An enumeration. */
export enum OrgwikiCustomSectionUpdateIntervalChoices {
  /** Monthly */
  Monthly = 'MONTHLY',
  /** Quarterly */
  Quarterly = 'QUARTERLY',
  /** Weekly */
  Weekly = 'WEEKLY',
  /** Yearly */
  Yearly = 'YEARLY'
}

/** An enumeration. */
export enum OrgwikiEmployeePreferredConferencingChoices {
  A = 'A_',
  /** skype */
  Skype = 'SKYPE',
  /** skype_business */
  SkypeBusiness = 'SKYPE_BUSINESS',
  /** webex */
  Webex = 'WEBEX',
  /** zoom */
  Zoom = 'ZOOM'
}

/** An enumeration. */
export enum OrgwikiEmployeePreferredMessagingChoices {
  A = 'A_',
  /** mattermost */
  Mattermost = 'MATTERMOST',
  /** slack */
  Slack = 'SLACK'
}

/** An enumeration. */
export enum OrgwikiSurveyStatusChoices {
  /** Cancelled */
  Cancelled = 'CANCELLED',
  /** Done */
  Done = 'DONE',
  /** Open */
  Open = 'OPEN',
  /** Pending */
  Pending = 'PENDING'
}

/** An enumeration. */
export enum PtoAllocationType {
  Accrued = 'ACCRUED',
  FrontLoaded = 'FRONT_LOADED'
}

/** The Relay compliant `PageInfo` type, containing data necessary to paginate this connection. */
export type PageInfo = {
  __typename?: 'PageInfo';
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['String']['output']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean']['output'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean']['output'];
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['String']['output']>;
};

export type ProductCategoryGroupingType = Node & {
  __typename?: 'ProductCategoryGroupingType';
  categories: ProductCategoryTypeConnection;
  groupingId: Scalars['IDInt']['output'];
  /** The ID of the object */
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};


export type ProductCategoryGroupingTypeCategoriesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type ProductCategoryGroupingTypeConnection = {
  __typename?: 'ProductCategoryGroupingTypeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<ProductCategoryGroupingTypeEdge>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `ProductCategoryGroupingType` and its cursor. */
export type ProductCategoryGroupingTypeEdge = {
  __typename?: 'ProductCategoryGroupingTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: ProductCategoryGroupingType;
};

export type ProductCategoryType = Node & {
  __typename?: 'ProductCategoryType';
  categoryId: Scalars['IDInt']['output'];
  grouping?: Maybe<ProductCategoryGroupingType>;
  hidden: Scalars['Boolean']['output'];
  /** The ID of the object */
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  products: ProductTypeConnection;
};


export type ProductCategoryTypeProductsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type ProductCategoryTypeConnection = {
  __typename?: 'ProductCategoryTypeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<ProductCategoryTypeEdge>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `ProductCategoryType` and its cursor. */
export type ProductCategoryTypeEdge = {
  __typename?: 'ProductCategoryTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: ProductCategoryType;
};

export type ProductType = Node & {
  __typename?: 'ProductType';
  category: ProductCategoryType;
  companyId: Scalars['IDInt']['output'];
  /** The ID of the object */
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  productId: Scalars['IDInt']['output'];
};

export type ProductTypeConnection = {
  __typename?: 'ProductTypeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<ProductTypeEdge>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `ProductType` and its cursor. */
export type ProductTypeEdge = {
  __typename?: 'ProductTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: ProductType;
};

/** An enumeration. */
export enum PublishStage {
  First = 'FIRST',
  Second = 'SECOND'
}

export type PublishSurveyResults = {
  __typename?: 'PublishSurveyResults';
  error?: Maybe<Error>;
  ok?: Maybe<Scalars['Boolean']['output']>;
  survey?: Maybe<SurveyType>;
};

export type Query = {
  __typename?: 'Query';
  accrualInfo?: Maybe<AccrualPeriodInfo>;
  canRemoveDomain?: Maybe<DomainValidator>;
  carryoverAdjustments?: Maybe<Array<Maybe<CarryoverAdjustment>>>;
  checkIn?: Maybe<CheckInType>;
  company?: Maybe<CompanyType>;
  companyConfig?: Maybe<CompanyConfigType>;
  customer?: Maybe<CustomerType>;
  customers?: Maybe<CustomerTypeConnection>;
  employee?: Maybe<EmployeeType>;
  employees?: Maybe<EmployeeTypeConnection>;
  groups?: Maybe<GroupTypeConnection>;
  market?: Maybe<MarketType>;
  markets?: Maybe<MarketTypeConnection>;
  memberships?: Maybe<GroupMemberTypeConnection>;
  securityListAdmins?: Maybe<AdminMembershipsType>;
  self?: Maybe<EmployeeType>;
  survey?: Maybe<SurveyType>;
  surveys?: Maybe<SurveyTypeConnection>;
  teamCheckIns?: Maybe<Array<CheckInType>>;
  validateDomain?: Maybe<DomainValidator>;
  viewableSecurityGroup?: Maybe<ViewableSecurityGroupTypeConnection>;
  wdBalanceInfo?: Maybe<WorkdayBalance>;
};


export type QueryAccrualInfoArgs = {
  after?: InputMaybe<Scalars['Date']['input']>;
  employeeId: Scalars['IDInt']['input'];
};


export type QueryCanRemoveDomainArgs = {
  customerId: Scalars['IDInt']['input'];
  domain: Scalars['String']['input'];
};


export type QueryCarryoverAdjustmentsArgs = {
  employeeId: Scalars['IDInt']['input'];
};


export type QueryCheckInArgs = {
  id: Scalars['IDInt']['input'];
};


export type QueryCustomerArgs = {
  id: Scalars['IDInt']['input'];
};


export type QueryCustomersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  customerIdIn?: InputMaybe<Array<InputMaybe<Scalars['IDInt']['input']>>>;
  employeeId?: InputMaybe<Scalars['IDInt']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isProspect?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
};


export type QueryEmployeeArgs = {
  id: Scalars['IDInt']['input'];
};


export type QueryEmployeesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  publicId?: InputMaybe<Scalars['String']['input']>;
  timeOffEnabled?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryGroupsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  subType?: InputMaybe<GroupsGroupSubTypeChoices>;
  type?: InputMaybe<GroupsGroupTypeChoices>;
};


export type QueryMarketArgs = {
  id: Scalars['IDInt']['input'];
};


export type QueryMarketsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
};


export type QueryMembershipsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  group_Type?: InputMaybe<GroupsGroupTypeChoices>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type QuerySecurityListAdminsArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  slugs: Array<InputMaybe<Scalars['String']['input']>>;
  sort?: InputMaybe<Scalars['String']['input']>;
};


export type QuerySurveyArgs = {
  id: Scalars['IDInt']['input'];
};


export type QuerySurveysArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryTeamCheckInsArgs = {
  managerId: Scalars['IDInt']['input'];
};


export type QueryValidateDomainArgs = {
  customerId?: InputMaybe<Scalars['IDInt']['input']>;
  domain: Scalars['String']['input'];
};


export type QueryViewableSecurityGroupArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryWdBalanceInfoArgs = {
  employeeId: Scalars['IDInt']['input'];
};

/** An enumeration. */
export enum ReportType {
  FirstLine = 'FIRST_LINE',
  RollUp = 'ROLL_UP'
}

export type RoleCategoryType = Node & {
  __typename?: 'RoleCategoryType';
  categoryId: Scalars['IDInt']['output'];
  /** The ID of the object */
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  roles: RoleTypeConnection;
};


export type RoleCategoryTypeRolesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type RoleCategoryTypeConnection = {
  __typename?: 'RoleCategoryTypeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<RoleCategoryTypeEdge>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `RoleCategoryType` and its cursor. */
export type RoleCategoryTypeEdge = {
  __typename?: 'RoleCategoryTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: RoleCategoryType;
};

export type RoleType = Node & {
  __typename?: 'RoleType';
  category: RoleCategoryType;
  /** The ID of the object */
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  roleId: Scalars['IDInt']['output'];
};

export type RoleTypeConnection = {
  __typename?: 'RoleTypeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<RoleTypeEdge>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `RoleType` and its cursor. */
export type RoleTypeEdge = {
  __typename?: 'RoleTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: RoleType;
};

export type SaveSearch = {
  __typename?: 'SaveSearch';
  error?: Maybe<Error>;
  ok?: Maybe<Scalars['Boolean']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type SetEmployeeCustomers = {
  __typename?: 'SetEmployeeCustomers';
  employee?: Maybe<EmployeeType>;
  error?: Maybe<Error>;
  ok: Scalars['Boolean']['output'];
  updatedMembers?: Maybe<Array<CustomerTeamMemberType>>;
  vcOk?: Maybe<Scalars['Boolean']['output']>;
};

export type SetHomepageText = {
  __typename?: 'SetHomepageText';
  companyConfig?: Maybe<CompanyConfigType>;
  error?: Maybe<Error>;
  ok?: Maybe<Scalars['Boolean']['output']>;
};

export type SetProductOrder = {
  __typename?: 'SetProductOrder';
  company?: Maybe<CompanyType>;
  error?: Maybe<Error>;
  ok?: Maybe<Scalars['Boolean']['output']>;
};

export type SkillCategoryType = Node & {
  __typename?: 'SkillCategoryType';
  displayOrder: Scalars['Int']['output'];
  externalId?: Maybe<Scalars['String']['output']>;
  /** The ID of the object */
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  tags: TagTypeConnection;
};


export type SkillCategoryTypeTagsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type SortObject = {
  categories?: InputMaybe<Array<CategorySortObject>>;
  id: Scalars['IDInt']['input'];
  products?: InputMaybe<Array<Scalars['IDInt']['input']>>;
  type: TopLevelType;
};

export type SurveyReportsType = Node & {
  __typename?: 'SurveyReportsType';
  employee?: Maybe<EmployeeType>;
  employeeId?: Maybe<Scalars['Int']['output']>;
  employeeName?: Maybe<Scalars['String']['output']>;
  /** The ID of the object */
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  reportId: Scalars['IDInt']['output'];
  survey?: Maybe<SurveyType>;
  type?: Maybe<ReportType>;
};

export type SurveyReportsTypeConnection = {
  __typename?: 'SurveyReportsTypeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<SurveyReportsTypeEdge>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** A Relay edge containing a `SurveyReportsType` and its cursor. */
export type SurveyReportsTypeEdge = {
  __typename?: 'SurveyReportsTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: SurveyReportsType;
};

export type SurveyType = Node & {
  __typename?: 'SurveyType';
  endTime?: Maybe<Scalars['DateTime']['output']>;
  firstLineReportTime?: Maybe<Scalars['DateTime']['output']>;
  /** The ID of the object */
  id: Scalars['ID']['output'];
  participants?: Maybe<Scalars['Int']['output']>;
  responses?: Maybe<Scalars['Int']['output']>;
  secondLineReportTime?: Maybe<Scalars['DateTime']['output']>;
  startTime?: Maybe<Scalars['DateTime']['output']>;
  status: OrgwikiSurveyStatusChoices;
  surveyId: Scalars['IDInt']['output'];
  title?: Maybe<Scalars['String']['output']>;
};

export type SurveyTypeConnection = {
  __typename?: 'SurveyTypeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<SurveyTypeEdge>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `SurveyType` and its cursor. */
export type SurveyTypeEdge = {
  __typename?: 'SurveyTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: SurveyType;
};

export type TagType = Node & {
  __typename?: 'TagType';
  category?: Maybe<SkillCategoryType>;
  employees: EmployeeTypeConnection;
  externalId?: Maybe<Scalars['String']['output']>;
  /** The ID of the object */
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  slugName?: Maybe<Scalars['String']['output']>;
  synonymOf?: Maybe<TagType>;
  synonyms: TagTypeConnection;
};


export type TagTypeEmployeesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  publicId?: InputMaybe<Scalars['String']['input']>;
  timeOffEnabled?: InputMaybe<Scalars['Boolean']['input']>;
};


export type TagTypeSynonymsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type TagTypeConnection = {
  __typename?: 'TagTypeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<TagTypeEdge>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `TagType` and its cursor. */
export type TagTypeEdge = {
  __typename?: 'TagTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: TagType;
};

/** An enumeration. */
export enum TimeOffAutoDeclineType {
  All = 'ALL',
  None = 'NONE',
  OnlyNew = 'ONLY_NEW'
}

export type TimeOffDayType = Node & {
  __typename?: 'TimeOffDayType';
  date: Scalars['Date']['output'];
  /** The ID of the object */
  id: Scalars['ID']['output'];
  timeOffDayId: Scalars['IDInt']['output'];
  timeOffEntry: TimeOffEntryType;
};

export type TimeOffDayTypeConnection = {
  __typename?: 'TimeOffDayTypeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<TimeOffDayTypeEdge>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `TimeOffDayType` and its cursor. */
export type TimeOffDayTypeEdge = {
  __typename?: 'TimeOffDayTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: TimeOffDayType;
};

export type TimeOffEntryType = Node & {
  __typename?: 'TimeOffEntryType';
  alternateContact?: Maybe<EmployeeType>;
  autoDecline?: Maybe<TimeOffAutoDeclineType>;
  autoResponderEnd?: Maybe<Scalars['DateTime']['output']>;
  autoResponderStart?: Maybe<Scalars['DateTime']['output']>;
  autoResponseBody?: Maybe<Scalars['String']['output']>;
  autoResponseSubject?: Maybe<Scalars['String']['output']>;
  backInOfficeDate?: Maybe<Scalars['Date']['output']>;
  deleted: Scalars['Boolean']['output'];
  description: Scalars['String']['output'];
  employee?: Maybe<EmployeeType>;
  /** The ID of the object */
  id: Scalars['ID']['output'];
  onlySendContacts?: Maybe<Scalars['Boolean']['output']>;
  onlySendInternal?: Maybe<Scalars['Boolean']['output']>;
  otherDescription?: Maybe<Scalars['String']['output']>;
  selectedEndDate?: Maybe<Scalars['Date']['output']>;
  selectedEndLength?: Maybe<DayLengthType>;
  selectedStartDate: Scalars['Date']['output'];
  selectedStartLength?: Maybe<DayLengthType>;
  teamCalendarId?: Maybe<Scalars['String']['output']>;
  timeOffDays: TimeOffDayTypeConnection;
  timeOffEntryId: Scalars['IDInt']['output'];
  timezone: Scalars['String']['output'];
  totalDays?: Maybe<Scalars['Float']['output']>;
  type?: Maybe<TimeOffType>;
  wdStartDate?: Maybe<Scalars['Date']['output']>;
};


export type TimeOffEntryTypeTimeOffDaysArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type TimeOffEntryTypeConnection = {
  __typename?: 'TimeOffEntryTypeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<TimeOffEntryTypeEdge>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `TimeOffEntryType` and its cursor. */
export type TimeOffEntryTypeEdge = {
  __typename?: 'TimeOffEntryTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: TimeOffEntryType;
};

export type TimeOffTotalType = {
  __typename?: 'TimeOffTotalType';
  skip2024?: Maybe<Scalars['Boolean']['output']>;
  years?: Maybe<Array<Maybe<TimeOffTotalYear>>>;
};

export type TimeOffTotalYear = {
  __typename?: 'TimeOffTotalYear';
  total?: Maybe<Scalars['Float']['output']>;
  year?: Maybe<Scalars['Int']['output']>;
};

/** An enumeration. */
export enum TimeOffType {
  Bereavement = 'BEREAVEMENT',
  JuryDuty = 'JURY_DUTY',
  Medical = 'MEDICAL',
  Other = 'OTHER',
  Parental = 'PARENTAL',
  Pto = 'PTO',
  Sick = 'SICK'
}

/** An enumeration. */
export enum TopLevelType {
  Category = 'CATEGORY',
  Grouping = 'GROUPING'
}

export type ViewableSecurityGroupType = Node & {
  __typename?: 'ViewableSecurityGroupType';
  /** The ID of the object */
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  slugName: Scalars['String']['output'];
};

export type ViewableSecurityGroupTypeConnection = {
  __typename?: 'ViewableSecurityGroupTypeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<ViewableSecurityGroupTypeEdge>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `ViewableSecurityGroupType` and its cursor. */
export type ViewableSecurityGroupTypeEdge = {
  __typename?: 'ViewableSecurityGroupTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node: ViewableSecurityGroupType;
};

export type WorkdayBalance = {
  __typename?: 'WorkdayBalance';
  balanceInfo?: Maybe<WorkdayBalanceInfo>;
  error?: Maybe<Error>;
};

export type WorkdayBalanceInfo = {
  __typename?: 'WorkdayBalanceInfo';
  carryoverExp: Scalars['Int']['output'];
  maxCarryover: Scalars['Float']['output'];
  minPtoBal: Scalars['Float']['output'];
  yearBalances?: Maybe<Array<Maybe<WorkdayYearBalanceInfo>>>;
  yearStart: Scalars['Date']['output'];
};

export type WorkdayYearBalanceInfo = {
  __typename?: 'WorkdayYearBalanceInfo';
  year: Scalars['Int']['output'];
  yearEarnedPto: Scalars['Float']['output'];
};
